import * as React from 'react';
import { useParams } from 'react-router-dom';
import dashboardWrapper from '~/wrappers/dashboard';
import { Panel, Spinner } from '@watcherr/ui';
import { t } from '~/i18n';
import { State } from '~/store/types';
import connect from '~/store/connect';
import ErrorContainer from '~/containers/Error';
import BackLink from '~/components/BackLink';
import HealthcareProviderFormContainer from '~/containers/HealthcareProviders/HealthcareProviderForm';

interface HealthcareProviderUpdatePageProps {
  healthcareProvider: State['healthcareProviderDetail']['profile'];
  loadHealthcareProvider: State['healthcareProviderDetail']['loadHealthcareProvider'];
  healthcareProviderLoading: State['healthcareProviderDetail']['loading'];
  healthcareProviderError: State['healthcareProviderDetail']['error'];
}

const HealthcareProviderUpdatePage: React.FC<HealthcareProviderUpdatePageProps> = ({
  healthcareProvider,
  loadHealthcareProvider,
  healthcareProviderLoading,
  healthcareProviderError,
}) => {
  const { id } = useParams<{ id: string }>();
  const healcareProviderId = id ? parseInt(id, 10) : 0;

  React.useEffect(() => {
    if (healthcareProviderLoading) {
      return;
    }
    if (healcareProviderId && (!healthcareProvider || healthcareProvider.id !== healcareProviderId)) {
      loadHealthcareProvider(healcareProviderId);
    }
  }, [healcareProviderId, healthcareProvider, healthcareProviderLoading, loadHealthcareProvider]);
  if (healthcareProviderLoading) {
    return <Spinner label={t('global.loading')} />;
  }
  return (
    <>
      <BackLink fallbackUrl={`/healthcare-providers`} name={t('healthcareProviderDetail.goBackToList')} />
      <ErrorContainer error={healthcareProviderError} />
      {!healthcareProviderError && (
        <Panel>
          <HealthcareProviderFormContainer healthcareProvider={healthcareProvider} />
        </Panel>
      )}
    </>
  );
};

const ConnectedHealthcareProviderUpdatePage = connect((state: State) => ({
  healthcareProvider: state.healthcareProviderDetail.profile,
  loadHealthcareProvider: state.healthcareProviderDetail.loadHealthcareProvider,
  healthcareProviderLoading: state.healthcareProviderDetail.loading,
  healthcareProviderError: state.healthcareProviderDetail.error,
}))(HealthcareProviderUpdatePage);

export default dashboardWrapper(ConnectedHealthcareProviderUpdatePage, t('healthcareProviders.update.title'));
